import createTrackingEventName from "app/pages/sales-intelligence/utils/testing/createTrackingEventName";
import type { track as TrackFn } from "pro-features/components/WithTrack/src/context";

enum ActionType {
    Click = "click",
    Hover = "hover",
}

enum FindSimilarCompaniesValueType {
    Industry = "industry",
    Tag = "tag",
}

export default function createOverviewTrackingService(track: TrackFn) {
    const trackCrmLink = (event: string) => {
        track("company card", "CRM link", event);
    };

    const trackCrmLinkHover = (event: string) => {
        track("company card", "CRM link hover", event);
    };

    const trackAddToList = (action: ActionType, eventName: string) => {
        track("add to list", action, eventName);
    };

    const trackFindSimilarCompanies = (value: string, valueType: FindSimilarCompaniesValueType) => {
        track("company card", ActionType.Click, `find similar companies/${value}/${valueType}`);
    };

    const trackAddToListButtonAction = (action: ActionType, listsCount: number = 0) => {
        const status = listsCount > 0 ? "already in a list" : "not in a list";

        const params: Array<string | number> = ["add to list", status];

        if (listsCount > 0) {
            params.push(listsCount);
        }

        trackAddToList(action, createTrackingEventName(...params));
    };

    return {
        trackOpenCRMAccountFromMultiple(accountId: string) {
            trackCrmLink(`open CRM account/multiple accounts/${accountId}`);
        },
        trackOpenCRMAccountFromSingle(accountId: string) {
            trackCrmLink(`open CRM account/one linked account/${accountId}`);
        },
        trackHoverCRMAccountFromSingle(accountId: string) {
            trackCrmLinkHover(`open CRM account/one linked account/${accountId}`);
        },
        trackHoverCRMAccountFromMultiple(accountId: string) {
            trackCrmLinkHover(`open CRM account/multiple accounts/${accountId}`);
        },
        trackAddToListClick(listsCount?: number) {
            trackAddToListButtonAction(ActionType.Click, listsCount);
        },
        trackAddToListHover(listsCount?: number) {
            trackAddToListButtonAction(ActionType.Hover, listsCount);
        },
        trackAddToListSelect(type: string) {
            trackAddToList(ActionType.Click, type);
        },
        trackTagClick(tag?: string) {
            trackFindSimilarCompanies(tag ?? "", FindSimilarCompaniesValueType.Tag);
        },
        trackIndustryClick(industry?: string) {
            trackFindSimilarCompanies(industry ?? "", FindSimilarCompaniesValueType.Industry);
        },
        trackAddToListHookClick() {
            track("sales intelligence hooks", "click", "Add to list hook/company analysis");
        },
    };
}
